import { VerifyOtpForUpdatingUserPinFailureArgsType } from '@flowwai-frontend/shared-web/iam/data-access'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

interface HookArgs {
   setErrorMessage: (errorMessage: string | null) => void
}

export const useErrorHandler = (args: HookArgs) => {
   const { setErrorMessage } = args

   const errorT = useCustomT('common:common.errorMessages')

   const handleError = (
      errorArgs: VerifyOtpForUpdatingUserPinFailureArgsType
   ) => {
      let errorMessage: string | null = null
      switch (errorArgs.data?.errorData.__typename) {
         case 'InvalidOTP': {
            errorMessage = errorT('invalidOTP')
            break
         }
         case 'OTPIsExpired': {
            errorMessage = errorT('otpExpired')
            break
         }
         case 'OTPLengthMismatched': {
            errorMessage = errorT('otpLengthMismatched')
            break
         }
         case 'OTPMaxRetriesExceeded': {
            errorMessage = errorT('otpMaxRetriesExceeded')
            break
         }
         default: {
            errorMessage =
               errorArgs.data?.message ?? errorT('somethingWentWrong')
         }
      }
      setErrorMessage(errorMessage)
   }

   return {
      handleError
   }
}
